<template>
  <el-menu
    :default-active="activeMenu"
    class="sidebar-menu"
    background-color="#304156"
    text-color="#bfcbd9"
    active-text-color="#409EFF"
    router
  >
    <template v-for="menu in menus">
      <!-- 跳过隐藏的菜单 -->
      <template v-if="!menu.meta || !menu.meta.hidden">
        <!-- 有子菜单的情况 -->
        <el-submenu v-if="menu.children && menu.children.length > 0" :key="menu.fullPath" :index="menu.fullPath">
          <template slot="title">
            <i :class="menu.icon" v-if="menu.icon"></i>
            <span>{{ menu.title || menu.meta.title }}</span>
          </template>
          <sidebar-menu-item
            v-for="child in menu.children.filter(c => !c.meta || !c.meta.hidden)"
            :key="child.fullPath || child.path"
            :menu="child"
            :base-path="menu.path"
          />
        </el-submenu>

        <!-- 没有子菜单的情况 -->
        <el-menu-item v-else :key="menu.fullPath || menu.path" :index="menu.fullPath || `${$route.matched[0].path}/${menu.path}`">
          <i :class="menu.icon" v-if="menu.icon"></i>
          <span>{{ menu.title || menu.meta.title }}</span>
        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>

<script>
import SidebarMenuItem from './SidebarMenuItem.vue'

export default {
  name: 'SidebarMenu',
  components: {
    SidebarMenuItem
  },
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.sidebar-menu {
  border: none;
}

.sidebar-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.sidebar-menu .el-submenu .el-menu-item {
  height: 45px;
  line-height: 45px;
  padding-left: 50px !important;
}
</style>